export enum LinkResult {
	SUCCESS = 'linked',
	ACCOUNT_TAKEN = 'account_taken'
}
